import { Exclude, Expose, Type } from 'class-transformer';
import { capitalize } from 'lodash-es';

export enum AccountType {
  INSTAGRAM = 'instagram',
  PINTEREST = 'pinterest',
  TIKTOK = 'tiktok',
  PLANOLY = 'planoly'
}

@Exclude()
export class AccountDTO {
  @Expose()
  @Type(() => String)
  id: string;

  @Expose()
  username: string;

  @Expose()
  pic: string;

  @Expose()
  type: AccountType;

  @Expose()
  isActive: boolean;

  @Expose()
  isDummy: boolean;

  @Expose()
  isOwner: boolean;

  @Expose()
  isBusiness: boolean;

  @Expose()
  isShoplink: boolean;

  @Expose()
  userId: number;

  @Expose()
  pins: number;

  @Expose()
  likes: number;

  @Expose()
  boards: number;

  @Expose()
  followers: number;

  @Expose()
  @Type(() => Boolean)
  isValidPinterestToken = true;

  @Expose()
  isValidTikTokToken: boolean;

  @Expose()
  isValidInstagramToken: boolean;

  @Expose()
  isValidFacebookToken: boolean;

  @Expose()
  @Type(() => Boolean)
  isPrimary: boolean;

  get isInstagram(): boolean {
    return this.type === AccountType.INSTAGRAM;
  }

  get isPinterest(): boolean {
    return this.type === AccountType.PINTEREST;
  }

  get isTiktok(): boolean {
    return this.type === AccountType.TIKTOK;
  }

  get isValidAccount(): boolean {
    if (this.isDummy || this.isTiktok) {
      // Tiktok Token validity TBD
      return this.isValidTikTokToken;
    } else if (this.isPinterest) {
      return this.isValidPinterestToken;
    } else if (this.isInstagram) {
      return this.isBusiness ? this.isValidFacebookToken : this.isValidInstagramToken;
    }
    return true;
  }

  get isPlanoly(): boolean {
    return this.type === AccountType.PLANOLY;
  }

  format(property: string): string {
    const value: number = this[property as keyof AccountDTO] as number;
    if (value < 1000) {
      return value.toString();
    }
    return `${(value / 1000).toFixed(2)}K`;
  }

  get typeDisplayName(): string {
    return capitalize(this.type);
  }
}
